import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TablePaginatorComponent } from '../table-paginator/table-paginator.component';
import { TableResultsTextComponent } from '../table-results-text/table-results-text.component';

@Component({
  selector: 'app-table-footer',
  templateUrl: './table-footer.component.html',
  styleUrls: ['./table-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TableResultsTextComponent, TablePaginatorComponent]
})
export class TableFooterComponent {
  @Input() totalCount!: number;
  @Input() pageSize!: number | null;
  @Input() skip: number = 0;
  @Output() skipChanged = new EventEmitter<number>();
}
